import { createCustomElement } from "@angular/elements";
import { createApplication } from "@angular/platform-browser";
import { wcAppConfig } from "./app/app.config";
import { FormViewerComponent } from "./app/modules/form-builder-viewer/pages/form-viewer/form-viewer.component";

createApplication(wcAppConfig).then((app) => {
    const formView = createCustomElement(FormViewerComponent, { injector: app.injector });
    customElements.define('form-view', formView);
}).catch((err) => console.error(err));